import { ChartOption, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const series = [];

  const seriesData: Array<Array<number>> = [];
  for (let j = 0; j < datas.rowCount; j++) {
    let data = [];
    if (datas.dataValues[datas.rowColIndexes[j][0]]) {
      data = datas.dataValues[datas.rowColIndexes[j][0]];
    } else {
      data = [0, 0];
    }
    data.push(parseInt(datas.rowDimNodes[j][0].label));
    seriesData.push(data);
  }

  let seriesLabel: any = {};
  if (!chartOption.hideLabel) {
    seriesLabel = {
      normal: {
        show: true,
        position: "top",
        formatter: function (params: any) {
          return params.value[2] + "年";
        },
      },
    };
  }

  series.push({
    type: "line",
    smooth: true,
    label: seriesLabel,
    data: seriesData,
  });

  const xAxis: any = {};
  const yAxis: any = {};

  if (!chartOption.hideAxisTitle) {
    xAxis.name = definition.measures[0].label;
    yAxis.name = definition.measures[1].label;
  }

  const option: any = {
    tooltip: {
      formatter: function (params: any) {
        const data = params.data || [0, 0];
        return data[2] + "年<br/>" + definition.measures[0].label + ":" + data[0] + "<br/>" + definition.measures[1].label + ":" + data[1];
      },
    },
    xAxis: xAxis,
    yAxis: yAxis,
    grid: {
      // top: '24%',
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: series,
  };

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title,
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.enableSwitchXY = true;
    option.toolbox = {
      show: true,
      feature: {
        saveAsImage: {},
      },
    };
  }

  return option;
}
